






































import { Component, Vue } from 'vue-property-decorator';

import AnalysisStepper from '@/components/analysis/AnalysisStepper.vue';
import AnalysisStepType from '@/components/analysis/steps/type/AnalysisStepType.vue';
import AnalysisStepConditions from '@/components/analysis/steps/conditions/AnalysisStepConditions.vue';
import AnalysisStepStation from '@/components/analysis/steps/station/AnalysisStepStation.vue';
import AnalysisStepSolesPair from '@/components/analysis/steps/solesPair/AnalysisStepSolesPair.vue';
import AnalysisStepAnalysis from '@/components/analysis/steps/analysis/AnalysisStepAnalysis.vue';

import { StepsKeys } from '@/plugins/podolib/services/analysis';

@Component({
  components: {
    AnalysisStepAnalysis,
    AnalysisStepSolesPair,
    AnalysisStepStation,
    AnalysisStepConditions,
    AnalysisStepType,
    AnalysisStepper,
  },
})
export default class PageAnalysis extends Vue {
  /**
   * Helper for giving ability to use types and enums in DOM
   */
  tsdom = {
    StepsKeys,
  };

  // -------------------------------------------------------------------------------------------------------------------

  /**
   * Get current step key
   */
  get currentStepKey() {
    return this.$pdc.analysis!.currentStepKey;
  }

  // -------------------------------------------------------------------------------------------------------------------

  next() {
    this.$pdc.analysis!.increaseStep();
  }
}
